import {addDates, cleanUndefined, mapSnapshot} from "../api";
import {firestore, getBasePath} from "../firebase";

export const FETCH_TASKS = "FETCH_TASKS";

export function fetchTasks(project, key) {
    return {
        type: FETCH_TASKS,
        meta: {key},
        payload: firestore
            .collection(getBasePath() + "/tasks")
            .get()
            .then(sh => mapSnapshot(sh))
    };
}

export function fetchTasksIfNeeded(project, key = "all") {
    if (!key) {
        throw new Error("Error in EntryActions.fetchEntriesIfNeededlocal: No key provided")
    }
    return (dispatch, state) => {
        const {tasks} = state();
        if (!tasks.isFetching[key] && !tasks.isFetched[key]) {
            dispatch(fetchTasks(project, key));
        }
    };
}

export const SAVE_TASK = "SAVE_TASK";

export function saveTask(params) {

    if (!params || !params.name || !params.project_id || !params.client_id) {
        throw new Error("Error creating task: params not ok")
    }

    cleanUndefined(params);
    addDates(params);

    params.project = firestore.doc(getBasePath() + "/projects/" + params.project_id);
    params.client = firestore.doc(getBasePath() + "/clients/" + params.client_id);
    delete params.client_id;
    delete params.project_id;

    if (params.id) {
        return (dispatch, getState) => {
            const {tasks} = getState();
            dispatch({
                type: SAVE_TASK,
                meta: {previousBudgetMinutes: tasks.items[params.id].budgetMinutes},
                payload: firestore
                    .doc(getBasePath() + "/tasks/" + params.id)
                    .update(params)
                    .then(() => params)
                    .then(sh => mapSnapshot(sh))
            });
        }
    } else {
        return {
            type: SAVE_TASK,
            meta: {previousBudgetMinutes: 0},
            payload: firestore
                .collection(getBasePath() + "/tasks")
                .add(params)
                .then(sh => mapSnapshot(sh))
        };
    }
}


// WEBPACK FOOTER //
// ./src/actions/TaskActions.js